/**
 * The wording versions of the two consent screens this build shows (DBS-266). They are sent with every consent the
 * applicant records, so the application's consent log says exactly what the applicant saw. Bump the constant
 * whenever a statement on the screen changes, and add the version to api/src/api/services/consents/wordingVersions.ts
 * and to the TSS page "Applicant consent screens: version map" (https://smartdbs.atlassian.net/wiki/spaces/TSS/pages/473989121).
 */

/** Statement of Fair Processing page: v4 = separately ticked fair processing, DBS privacy notice and e-result consent (DBS-337) */
export const CONSENT_PAGE_VERSION = 'v4'

/** Review page privacy notice confirmation: v2 = the DBS-mandated sentence and link (DBS-330) */
export const REVIEW_PAGE_VERSION = 'v2'
